/** Go to line (1-based), §16.3 — byte index for textarea.setSelectionRange. */
export function gotoLineOffset(text: string, lineOneBased: number): number {
  if (lineOneBased <= 1) return 0;
  let line = 1;
  let i = 0;
  while (i < text.length && line < lineOneBased) {
    if (text[i] === "\r" && text[i + 1] === "\n") {
      i += 2;
      line++;
    } else if (text[i] === "\n" || text[i] === "\r") {
      i += 1;
      line++;
    } else {
      i += 1;
    }
  }
  return i;
}
